import React, { useEffect, useState, useRef } from "react";
import { Box, Container, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import HeroBanner from "./HeroBanner";
import SectionTitle from "./SectionTitle";
import CompanyLogosStrip from "./CompanyLogosStrip";
import FeatureHighlightsStrip from "./FeatureHighlightsStrip";
import TestimonialsSection from "./TestimonialsSection";

const GrazeBoxesPage = () => {
  const navigate = useNavigate();
  const [grazeBoxProducts, setGrazeBoxProducts] = useState([]);
  const targetSectionRef = useRef(null);

  useEffect(() => {
    document.title = "Graze Boxes";
  }, []);

  useEffect(() => {
    const fetchGrazeBoxes = async () => {
      try {
        const res = await api.get("/graze-boxes");
        console.log(res.data);
        setGrazeBoxProducts(res.data);
      } catch (err) {
        console.error("Failed to fetch graze boxes:", err);
      }
    };

    fetchGrazeBoxes();
  }, []);

  const scrollToSection = () => {
    targetSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleOrderButtonClick = (product) => {
    navigate("/shop/graze-boxes/details", {
      state: { product },
    });
  };

  return (
    <Box>
      <HeroBanner onClick={scrollToSection} />
      <CompanyLogosStrip />

      {/* Product Grid */}
      <Box ref={targetSectionRef} sx={{ mt: 8, mb: 10 }}>
        <SectionTitle text="Shop By Style" />
        <Container maxWidth="xl">
          <Grid container spacing={4}>
            {grazeBoxProducts.map((product) => (
              <Grid item xs={12} sm={6} md={4} key={product._id}>
                <Box
                  sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: 2,
                    bgcolor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}>
                  <Box
                    component="img"
                    src={product.coverImage}
                    alt={product.name}
                    sx={{
                      width: "100%",
                      height: 300,
                      objectFit: "cover",
                    }}
                  />
                  <Box sx={{ p: 2, flexGrow: 1 }}>
                    <Box sx={{ mb: 1, fontWeight: 600 }}>{product.name}</Box>
                    <Box sx={{ color: "gray", mb: 1 }}>
                      based on {product.shortInfo}
                    </Box>
                    <Box sx={{ color: "#555" }}>
                      {product.servings || "Perfect for events"}
                    </Box>
                  </Box>
                  <Box sx={{ px: 2, pb: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => handleOrderButtonClick(product)}
                      sx={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        textTransform: "none",
                        borderRadius: "8px",
                      }}>
                      Customize and Order
                    </Button>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <FeatureHighlightsStrip />
      <TestimonialsSection />
    </Box>
  );
};

export default GrazeBoxesPage;
